export const VENUE_DETAIL = 'venue/detail';
export const SITE_LIST = "site/list";
export const CreateOrder = "createOrder";
export const VENUE_DETAIL_INFO = 'venue/detailInfo';

